import React, { useState } from "react";
import { login } from "../api/auth";

export default function LoginForm({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const data = await login(username, password);
      onLogin(data.token, data.name);
    } catch {
      setError("Usuario o contraseña incorrectos");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-6 flex flex-col gap-4 max-w-sm mx-auto mt-16 bg-white rounded-2xl shadow-xl">
      <h1 className="text-xl font-bold">Login</h1>
      <input className="input input-bordered" placeholder="Usuario" value={username} onChange={(e) => setUsername(e.target.value)} />
      <input className="input input-bordered" placeholder="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <button className="btn btn-primary" type="submit">
        Entrar
      </button>
      {error && <div className="text-red-500">{error}</div>}
    </form>
  );
}
